@if (formReady()) {
  <app-access-control [flagsForm]="flagsForm" [allFlags]="allFeatureFlags"> </app-access-control>
  <app-permissions
    [facilities]="currentProductGroups"
    (facilitiesChange)="onPermissionsChanged($event)"
    (validityChange)="onPermissionsValidityChange($event)">
  </app-permissions>
}
